export default __webpack_public_path__ + "static/media/skillrating-checkin-notification-icon.02a1f268.svg";